import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function CostControl() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className="p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">Supply Chain and Procurement</h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/supply-chain/vendor-management')}
              className="btn"
            >
              Vendor Management
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/supply-chain/inventory-procurement')}
              className="btn "
            >
              Inventory and Procurement
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/supply-chain/cost-control-budgeting')
              }
              className="btn text-black font-bold"
            >
              Cost Control and Budgeting
            </button>
          </div>
        </header>
        <ComingSoon />
      </div>
    </div>
  );
}

export default CostControl;
